import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="bg-[#0a0a0a] pt-28 pb-12 md:pt-36 md:pb-16 px-4 overflow-hidden" data-id="element-103">
      <div className="max-w-6xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-105">
          <div className="inline-flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-full px-4 py-2 mb-6" data-id="element-106">
            <div className="flex text-yellow-500" data-id="element-107">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} fill="currentColor" data-id="element-108" />)}
            </div>
            <span className="text-sm font-medium text-zinc-300" data-id="element-109">
              +1200 personas ya cocinan con Cocina Veggie
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight max-w-4xl mb-8" data-id="element-110">
            Recetas Veganas y Vegetarianas para{' '}
            <span className="text-emerald-500" data-id="element-111">Comer Rico Todos los Días</span>
          </h1>

          {/* Portada Principal */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative w-full max-w-sm md:max-w-md flex items-center justify-center mb-8" data-id="element-112">
            <img src="https://cdn.magicpatterns.com/uploads/n4jHwvFKXMHBHaytFaqo4b/heylloyd-image-1773257137853_(1).png" alt="Cocina Veggie — Pack Digital 6 Tomos PDF" className="w-full h-auto rounded-xl shadow-[0_20px_60px_rgba(0,0,0,0.6)]" data-id="element-113" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-emerald-500/15 blur-[80px] rounded-full -z-10" data-id="element-114"></div>
          </motion.div>

          <p className="text-lg md:text-xl text-zinc-400 leading-relaxed max-w-3xl mb-8" data-id="element-115">
            El pack definitivo para quienes quieren comer más vegetal, sin
            aburrirse, sin ingredientes raros y sin pasar horas en la cocina.
            Todo con ingredientes de tu feria o almacén.
          </p>

          <CTAButton href="#pricing" data-id="element-116">QUIERO MI PACK AHORA →</CTAButton>
        </motion.div>
      </div>
    </section>;
}